// @flow
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const ContainerWrapper: StatelessFunctionalComponent<*> = styled.div`
  margin-left: auto !important;
  margin-right: auto !important;
  max-width: 1200px;
  width: 100%;

  @media screen and (max-width: 1230px) {
    padding-right: 15px !important;
    padding-left: 15px !important;
  }
`;

export default ContainerWrapper;
